//let regularCheckoutFlg = false;
illb2bJq(function () {

  //見積を依頼するボタンクリック時の処理
  illb2bJq(document).on('click', "#ill-b2b-quotation-request", function (e) {
    ajaxQuotationRequest();
  });
  //アカウント招待ダイアログ表示
  illb2bJq(document).on('click', "#ill-b2b-invite-account-a", function (e) {
    e.preventDefault();
    openInviteAccountDialog();
  });
  //アカウント招待ダイアログ非表示
  illb2bJq(document).on('click', ".modal-close, .modal-overlay", function (e) {
    closeInviteAccountDialog();
  });
  //アカウント招待ダイアログ招待送信ボタン
  illb2bJq(document).on('click', "#invite-account-button", function (e) {
    ajaxInviteAccount();
  });

  disableVariantSubmit(); //カート制御

  //variantの監視
  const callback_addons = (mutationList, observer_addons) => {
    for (const mutation of mutationList) {
      disableVariantSubmit(); //カート制御
    }
  };
  const observer_addons = new MutationObserver(callback_addons);
  const targetVariantNodes = document.querySelectorAll(".product-form__input"); //もし正常動作しない場合これが原因1
  targetVariantNodes.forEach(targetNode => {
    observer_addons.observe(targetNode, { attributes: true, childList: true, subtree: true });
  });

  //注文履歴再注文
  illb2bJq("#ill_buy_order_again").on('click', function () {
    screenLock(document.querySelector("#ill_buy_order_again"));
    const shopUrl = illb2bJq("#ill_b2b_store_host").val();
    let variant_list = illb2bJq("#illb2b_reorder_variant_list").val();
    let variant_array = variant_list.replace(/_/g, ',').replace(/'/g, '"');
    
    // 現在のカートの中身をクリアして対象の商品をカートに入れる
    fetch(`https://${shopUrl}/cart/clear.js`,{method: 'POST'})
    .then(response => {   
      ill_b2b_reorder(variant_array); //注文履歴の商品をカートに追加
    })
    .catch((error) => {
      console.log(error);
      openMessageDialog("商品をカートに入れることができませんでした。対象の商品が在庫切れ・販売停止中などの可能性があります。");
      screenUnlock();
    });
  })

  /*
  //コレクション商品選択モード変更ボタン
  illb2bJq("#ill-b2b_quick-add-select").on('click', function () {
    var checkProducts = illb2bJq(".js_ill-b2b_check-product");
    checkProducts.removeClass("hide");
    illb2bJq(this).hide();
    //選択されているチェックボックスがあれば数量を表示
    illb2bJq.each(checkProducts,function(){
      if(illb2bJq(this).find('.ill-b2b_quick-add-checkbox').prop('checked')){
        illb2bJq(this).next(".ill-b2b_product-input-num").find(".ill-b2b_input-variant-box").removeClass("hide_force");
      }
    });
    illb2bJq("#ill-b2b_quick-add-cart").show();
  });

  //コレクション選択閉じる
  illb2bJq(".ill-b2b_quick-add_modal-close").on('click', function(){
    illb2bJq(".js_ill-b2b_check-product").addClass("hide");
    illb2bJq("#ill-b2b_quick-add-cart").hide();
    illb2bJq(".ill-b2b_input-variant-box").addClass("hide_force");
    illb2bJq("#ill-b2b_quick-add-select").show();
  });

  //単一商品数量選択
  illb2bJq(".js_ill-b2b_check-product").on('click', function () {
    if(illb2bJq(this).find(".ill-b2b_quick-add-checkbox").prop("checked")){
      illb2bJq(this).next("div").find(".ill-b2b_input-variant-box").removeClass("hide_force");
    }else{
      illb2bJq(this).next("div").find(".ill-b2b_input-variant-box").addClass("hide_force");
    }
  });

  //variantが選択されたとき
  illb2bJq(".js_ill-b2b_quick-add_variant").on('click',function() {
    var variantBox = illb2bJq(`#ill-b2b_input-variant-box_${illb2bJq(this).val()}`);
    if(illb2bJq(this).prop("checked")){
      variantBox.removeClass("hide_force");
    }else{
      variantBox.addClass("hide_force");
    }
  });

  //コレクションでSKUモーダル表示
  illb2bJq(".js_ill-b2b_quick-add_open-variant").on('click',function() {
    var productData = illb2bJq(this).data('product');
    let productBox = illb2bJq(this).parents(".js_ill-b2b_check-product");

    //親チェックを無効にする(ほかのinputがアクティブにならないようすべてdisable)
    illb2bJq(".ill-b2b_quick-add-checkbox").prop('disabled', true);

    //コンテンツ最上位のtranslateを削除する（テーマごとに違うので注意）
    illb2bJq(this).parents("li").removeClass("animate--slide-in");
    illb2bJq("#ProductGridContainer").removeClass("animate--slide-in");

    productBox.find(".ill-b2b_quick-add_select-variants").removeClass("hide");
    illb2bJq(".js_ill-b2b_quick-add_open-variant").addClass("pointer-events_none");

    //オーバーレイにdata属性を指定する
    illb2bJq(".modal-overlay").data('product', productData);
    illb2bJq(".modal-overlay").fadeIn(100);
    illb2bJq("body").attr('style', 'overflow: hidden'); //数が多いときにスクロール

    illb2bJq("#ill-b2b_quick-add-cart").hide();
  });

  //skuモーダル解除
  illb2bJq('.modal-close, .modal-overlay, .ill-b2b_quick-add_select-variants_close').on('click',function(){
    var productData = illb2bJq(this).data('product');

    //variantが一つもチェックされていないときは親のチェックを入れない
    var is_variant_checked = false; 
    illb2bJq(`#ill-b2b-variants_${productData}`).find(".js_ill-b2b_quick-add_variant").each(function() {
      if(illb2bJq(this).prop('checked')){
        is_variant_checked = true;
        return false;
      }
    });
    console.log(is_variant_checked);
    let productCheck = illb2bJq(`#input_${productData}`);
    if(!is_variant_checked){
      productCheck.removeAttr('checked').prop('checked', false).change();
    }else{
      productCheck.attr('checked', true).prop('checked', true).change();
    }
    //購入可能な商品のみdisabled解除
    illb2bJq(".ill-b2b_quick-add-checkbox").each(function() {
      if(illb2bJq(this).data('available')=="ture"){
        illb2bJq(this).prop('disabled', false);
      }
    });
    illb2bJq(".js_ill-b2b_quick-add_open-variant").removeClass("pointer-events_none");
    illb2bJq("body").attr('style', 'overflow:');
    illb2bJq(".modal-overlay").fadeOut();
    illb2bJq(".ill-b2b_quick-add_select-variants").addClass("hide");

    illb2bJq("#ill-b2b_quick-add-cart").show();
  });

  //全選択
  illb2bJq("#ill-b2b_check-all").on('click', function () {    
    //【単一SKU】購入可能な商品のみチェックを入れて数量表示
    let add_product=illb2bJq(".ill-b2b_quick-add-checkbox");
    add_product.each(function() {
      if(illb2bJq(this).data('available')=="ture"){
        illb2bJq(this).prop("checked",true);
        var variant = illb2bJq(this).data('variant');
        illb2bJq(`#ill-b2b_input-product-box_${variant}`).removeClass("hide_force");
      }
    });
    //【複数SKU】購入可能なSKUのみチェックを入れて数量表示
    let add_variant = illb2bJq(".js_ill-b2b_quick-add_variant");
    add_variant.each(function() {
      if(illb2bJq(this).data('available')=="ture"){
        illb2bJq(this).prop("checked",true);
        var variant = illb2bJq(this).data('variant');
        illb2bJq(`#ill-b2b_input-variant-box_${variant}`).removeClass("hide_force");
      }
    });
  });

  //選択解除
  illb2bJq("#ill-b2b_no-check").on('click', function () {
    illb2bJq(".ill-b2b_quick-add-checkbox").prop("checked",false);
    illb2bJq(".js_ill-b2b_quick-add_variant").prop("checked",false);
    illb2bJq(".ill-b2b_input-variant-box").addClass("hide_force");
  });


  //カート一括投下
  illb2bJq("#ill-b2b_quick-add-btn").on('click', function () {
    quickCartIn();
  });
  
  //数量変更
  illb2bJq(".js_ill-b2b_quick-add_number").on('click', function (e) {
    e.preventDefault();
    let fieldName = illb2bJq(this).attr("data-field");
    let type = illb2bJq(this).attr("data-type");
    var input = illb2bJq(`#${fieldName}`);
    var currentVal = parseInt(input.val());
    if (!isNaN(currentVal)) {
      if (type == "minus") {
        if (currentVal > input.attr("min")) {
          input.val(currentVal - 1).change();
        }
        if (parseInt(input.val()) == input.attr("min")) {
          illb2bJq(this).attr("disabled", true);
        }
      }else if (type == "plus") {
        if (parseInt(input.val()) >= input.attr("min")) {
          illb2bJq(`#${fieldName}_minus`).attr("disabled", false);
        }
        input.val(currentVal + 1).change();
      }
    } else {
      input.val(0);
    }
  });

  illb2bJq(".ill-b2b_quick-add_input-number").focusin(function () {
    illb2bJq(this).data("oldValue", illb2bJq(this).val());
  });
  
  illb2bJq(".ill-b2b_quick-add_input-number").change(function () {
    minValue = parseInt(illb2bJq(this).attr("min"));
    valueCurrent = parseInt(illb2bJq(this).val());
    name = illb2bJq(this).attr("name");
    if (valueCurrent >= minValue) {
      illb2bJq(".js_ill-b2b_quick-add_number[data-type='minus'][data-field='" + name + "']").removeAttr("disabled");
    } else {
      illb2bJq(this).val(illb2bJq(this).data("oldValue"));
    }
  });

  illb2bJq(".ill-b2b_quick-add_input-number").keydown(function (e) {
    if (
      illb2bJq.inArray(e.keyCode, [46, 8, 9, 27, 13, 190]) !== -1 ||
      (e.keyCode == 65 && e.ctrlKey === true) ||
      (e.keyCode >= 35 && e.keyCode <= 39)
    ) {
      return;
    }
    if (
      (e.shiftKey || e.keyCode < 48 || e.keyCode > 57) &&
      (e.keyCode < 96 || e.keyCode > 105)
    ) {
      e.preventDefault();
    }
  });
  */
});


//variant非表示制御（隠せないのでカート投下を制御）
function disableVariantSubmit(){
  let cart_button = illb2bJq(".product-form__submit");
  cart_button.removeClass("hide");
  let target_variant_id = getParam("variant");
  if(!target_variant_id){
    target_variant_id = illb2bJq('#first_available_variant').val();
  }
  let b2b_hide_variant_list = illb2bJq('#b2b_hide_variant_list').val();
  if(!b2b_hide_variant_list){
    return;
  }
  let priceItem = illb2bJq(".price-item")[0]; //もし正常動作しない場合これが原因2
  let b2b_hide_variant_arry = b2b_hide_variant_list.split(",");
  console.log(target_variant_id);
  b2b_hide_variant_arry.forEach(variant_id => {
    if(variant_id == target_variant_id){
      if(priceItem.textContent != "販売停止"){
        priceItem.textContent = "販売停止";
      }
      cart_button.addClass("hide");
    }
  });
}

//カート一括投下
function quickCartIn(){
  var items = [];
  //単一SKU商品
  illb2bJq('input[name=ill-b2b_quick-add_product]:checked').each(function() {
    var variantId = illb2bJq(this).val();
    var quantity = illb2bJq(`#ill_quick_quantity_${variantId}`).val();
    items.push({'id': variantId,'quantity': quantity});
  });
  //複数SKU商品
  illb2bJq('input[name=ill-b2b_quick-add_variant]:checked').each(function() {
    var variantId = illb2bJq(this).val();
    var quantity = illb2bJq(`#ill_quick_quantity_${variantId}`).val();
    items.push({'id': variantId,'quantity': quantity});
  });
  //選択されていなければ終了
  if(items.length == 0){
    openMessageDialog("カートに追加する商品を選択してください。");
    return;
  }
  let formData = {'items': items};
  screenLock();
  illb2bJq("#ill-b2b_quick-add-btn").find('span').addClass('ill-b2b-hidden');
  illb2bJq("#ill-b2b_quick-add-btn").find('.loading-overlay__spinner').removeClass('ill-b2b-hidden');
  illb2bJq.ajax({
    url: window.Shopify.routes.root + 'cart/add.js',
    type: 'POST',
    headers: {
    'Content-Type': 'application/json'
    },
    dataType: 'json',
    data: JSON.stringify(formData),
    timeout: 30000,
  }).done(function (data) {
    openMessageDialog("選択した商品をカートに追加しました。");
  }).fail(function (XMLHttpRequest, textStatus, errorThrown) {
    openMessageDialog("選択した商品をカートに追加できませんでした。売り切れ状況などを各商品ページにてお確かめください。");
  }).always(function (data){
    screenUnlock();
    illb2bJq("#ill-b2b_quick-add-btn").find('span').removeClass('ill-b2b-hidden');
    illb2bJq("#ill-b2b_quick-add-btn").find('.loading-overlay__spinner').addClass('ill-b2b-hidden');
  });
}

//Ajax見積依頼時処理
function ajaxQuotationRequest() {
  screenLock();
  illb2bJq("#ill-b2b-quotation-request").find('span').addClass('ill-b2b-hidden');
  illb2bJq("#ill-b2b-quotation-request").find('.loading-overlay__spinner').removeClass('ill-b2b-hidden');
  
  var hostUrl = '/apps/b2b-custom_dev/quotation-request-create';
  var cart = getCart();
  illb2bJq.ajax({
    url: hostUrl,
    type: 'POST',
    dataType: 'json',
    data: {
      cart: cart,
      customerId:  illb2bJq('#ill_b2b_customer_id').val(),
    },
    timeout: 30000,
  }).done(function (data) {
    if (data.status == 'success') {
      illb2bJq("#ill-b2b-message-dialog-ok_button").on("click", function () {
          window.location.href = location.origin;
      });
      openMessageDialog("見積依頼が完了しました。");
    } else {
      openMessageDialog(data.result);
    }
  }).fail(function (XMLHttpRequest, textStatus, errorThrown) {
    openMessageDialog("通信エラーが発生しました。時間をあけて再度お試しください");
  }).always(function (data){
    screenUnlock();
    illb2bJq("#ill-b2b-quotation-request").find('span').removeClass('ill-b2b-hidden');
    illb2bJq("#ill-b2b-quotation-request").find('.loading-overlay__spinner').addClass('ill-b2b-hidden');
  });
}
  
//cart取得
function getCart() {
  var result = illb2bJq.ajax({
    url: '/cart.js',
    dataType: 'json',
    async: false
  }).responseText;
  return result;
}

function clearCart() {
  var result = illb2bJq.ajax({
    url: '/cart/clear.js',
    dataType: 'json',
    async: false
  }).responseText;
  return result;
}

function updateCartAttributes(updateData) {
  var result = illb2bJq.ajax({
    url: '/cart/update.js',
    data: updateData,
    dataType: 'json',
    async: false
  }).responseText;
  return result;
}

//アカウント招待ダイアログ表示
function openInviteAccountDialog() {
  illb2bJq("body").attr('style', 'overflow: hidden');
  illb2bJq(".modal-overlay").fadeIn(); 
  illb2bJq(".invite-account-modal").fadeIn(); 
}
//アカウント招待ダイアログ非表示
function closeInviteAccountDialog() {
  illb2bJq("body").attr('style', 'overflow:');
  illb2bJq(".modal-overlay").fadeOut();
  illb2bJq(".invite-account-modal").fadeOut();
}
//Ajaxアカウント招待
function ajaxInviteAccount() {
  illb2bJq("#invite-account-button").find('span').addClass('invite-account-hidden');
  illb2bJq("#invite-account-button").find('.loading-overlay__spinner').removeClass('invite-account-hidden');
  screenLock();
  var hostUrl = '/apps/ill_b2b/child-account-invitation-request';
  illb2bJq.ajax({
    url: hostUrl,
    type: 'POST',
    dataType: 'json',
    data: {
      id: illb2bJq('#ill_b2b_customer_id').val(),
      email: illb2bJq('#invite-account-email').val(),
    },
    timeout: 30000,
  }).done(function (data) {
    if (data.status == 'success') {
      illb2bJq('#invite-account-email').val("");
      closeInviteAccountDialog();
      openMessageDialog("招待を送信しました。");
    } else {
      openMessageDialog(data.result);
    }
  }).fail(function (XMLHttpRequest, textStatus, errorThrown) {
    openMessageDialog("通信エラーが発生しました。時間をあけて再度お試しください");
  }).always(function (data){
    illb2bJq("#invite-account-button").find('span').removeClass('invite-account-hidden');
    illb2bJq("#invite-account-button").find('.loading-overlay__spinner').addClass('invite-account-hidden');
    screenUnlock();
  });
}

//注文履歴の商品をカートに追加
function ill_b2b_reorder(variant_array){
  let formData ={
    "items": illb2bJq.parseJSON(variant_array)
  }
  illb2bJq.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: formData,
    dataType: 'json',
    timeout: 30000,
  }).done(function (data) {
    window.location.href = '/cart';
    screenUnlock();
    //illb2b_update_cart_note();
  }).fail(function (XMLHttpRequest, textStatus, errorThrown) {
    console.log(XMLHttpRequest);
    openMessageDialog("商品をカートに入れることができませんでした。対象の商品が在庫切れ・販売停止中などの可能性があります。");
    screenUnlock();
  });
}

// URLから指定したパラメータを取得
function getParam(name, url) {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
  results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}